import { DurationPicker as DurationPickerComponent } from '@randstad-lean-mobile-factory/react-components-core';
import classnames from 'classnames';
import moment from 'moment';
import { FieldPath, FieldValues, useController } from 'react-hook-form';

import { ErrorMessage } from '../ErrorMessage';

import styles from './DurationPicker.module.scss';
import { Props, Duration } from './DurationPicker.types';

export const DurationPicker = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  name,
  control,
  defaultValue,
  disabled,
  containersClassName,
  formFieldClassName,
  ...durationPickerProps
}: Props<TFieldValues, TName>) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue,
    disabled,
  });

  const { hours, minutes } = field.value as Duration;
  const duration = moment.duration(hours * 60 + minutes, 'm');

  return (
    <div className={formFieldClassName}>
      <DurationPickerComponent
        onChange={value => {
          field.onChange({ hours: Math.floor(value.asHours()), minutes: value.minutes() });
        }}
        duration={duration}
        {...durationPickerProps}
        containersClassName={classnames(containersClassName, {
          [styles.error]: error !== undefined,
        })}
      />
      <ErrorMessage error={error} />
    </div>
  );
};
